

import detailedPersonalityIcon from "../assets/images/detailed-persoonality.svg";

import disable_detailed_personality from "../assets/images/detailed_personality_disable.svg";
import processing from '../assets/images/detailed_personality_processing.svg'


function detailedPersonalityMessage(status){

    switch (status) {
        case 'Not Generated':
        case null:
            return {
                message:'Create Detailed Personality',
                label:'Create Detailed Personality',
                icon:disable_detailed_personality,
            } 
        case 'Processing':
            return {
                message:'Detailed Personality report is getting processed ',
                label:'Detailed Personality Processing',
                icon:processing
            }
        default:
            return {
                message:'View Detailed Personality',
                label:'View Detailed Personality',
                icon:detailedPersonalityIcon
            }
    }

}

export default detailedPersonalityMessage